import $ from 'jquery';
import NativeShare from 'nativeshare';
import Env from './env';

const IMG_PREFIX = 'https://tb.mgtv.com/page-facotry/resources/icons/share';

const MG_MENU_ITEMS = [
  {
    type: 'wechat',
    title: '微信好友',
  },
  {
    type: 'moments',
    title: '朋友圈',
  },
  {
    type: 'qq',
    title: 'QQ',
  },
  {
    type: 'qzone',
    title: 'QQ空间',
  },
  {
    type: 'refresh',
    title: '刷新',
  },
  {
    type: 'copy',
    title: '复制链接',
  },
];

export default class ShareManager {
  constructor(bridge) {
    this.bridge = bridge;
    this.modal = null;
    if (this.shareInfo) {
      if (Env.isWeixin) {
        this.initWeixinShare();
      }
    }
  }

  setShare(shareInfo) {
    this.shareInfo = shareInfo;
    if (shareInfo) {
      if (Env.isWeixin) {
        this.initWeixinShare(shareInfo);
      } else if (!Env.isMgtvApp) {
        const {
          desc, title, img, url: link = location.href,
        } = shareInfo;
        console.log(shareInfo);
        setTimeout(() => {
          let descMeta = document.querySelector('meta[name="description"]');
          if (!descMeta) {
            descMeta = document.createElement('meta');
            descMeta.setAttribute('name', 'description');
            document.head.appendChild(descMeta);
          }
          descMeta.setAttribute('content', desc);
        });
        if (Env.isQQApp) {
          this.initByQQShare(shareInfo);
        } else {
          if (!this.nativeShare) {
            this.nativeShare = new NativeShare();
          }
          this.nativeShare.setShareData({
            icon: img,
            link,
            title,
            desc,
          });
        }
      } else {
        this.initMGShare(shareInfo)
      }
      // else {
      // }
    }
  }

  showNativeShare() {
    this.nativeShare.call();
  }

  setShareCallback(func) {
    this.shareCallback = func;
  }

  initByQQShare(shareInfo) {
    const {
      desc, title, img, url: shareUrl = location.href,
    } = shareInfo;
    // $.getScript((`./share.js?rnd=${Date.now()}`), () => {
    $.getScript('https://qzonestyle.gtimg.cn/qzone/qzact/common/share/share.js', () => {
      window.setShareInfo({
        title, // 分享标题
        summary: desc, // 分享内容
        pic: img, // 分享图片
        url: shareUrl, // 分享链接
        // callback: (resp) => {
        //   if (this.shareCallback) {
        //     this.shareCallback(resp);
        //   }
        // },
      });
    });
  }

  initMGShare(shareInfo) {
    const { bridge } = this;
    if (bridge) {
      const {
        desc, title, img, url = location.href,
      } = shareInfo;
      bridge.runTask((mgApi) => {
        const callback = () => {
          mgApi.callhandler(
            'showShareMenus',
            {
              title, // 分享标题
              desc, // 分享描述
              shareUrl: url, // 分享链接
              shareIcon: img, // 分享图片
            },
            (resp) => {
              if (this.shareCallback) {
                this.shareCallback(resp);
              }
            },
          );
        };
        callback();
      });
    }
  }

  initWeixinShare(shareInfo) {
    const { bridge } = this;
    if (bridge) {
      bridge.runTask((wx) => {
        const {
          desc, title, img: imgUrl, url: link = location.href,
        } = shareInfo;
        // const link = `https://tb.mgtv.com/redirect.html?target=${encodeURIComponent(
        //   window.location.href
        // )}`
        const success = () => {
          if (this.shareCallback) {
            this.shareCallback({ data: { value: 1 } });
          }
        };
        /* 安卓可能不支持新的API 所以还需要加 1.2.0版本的api */
        wx.onMenuShareTimeline({
          title,
          link,
          imgUrl,
          success,
        });
        wx.onMenuShareAppMessage({
          title,
          desc,
          link,
          imgUrl,
          success,
        });
        if (wx.updateAppMessageShareData) {
          // “分享给朋友”及“分享到QQ”按钮的分享内容 1.4.0
          wx.updateAppMessageShareData({
            title,
            desc,
            link,
            imgUrl,
            success,
          });
        }
        if (wx.updateTimelineShareData) {
          // 分享到朋友圈”及“分享到QQ空间 1.4.0
          wx.updateTimelineShareData({
            title,
            link,
            imgUrl,
            success,
          });
        }
      });
    }
  }

  setShowToast(func) {
    this.showToast = func;
  }

  createMGMenu(modal) {
    modal.addClass('app-modal');
    const list = $('<ul>').addClass('btn-list');
    MG_MENU_ITEMS.forEach(({ type, title }) => {
      const img = $('<img>').attr('src', `${IMG_PREFIX}/${type}.png`);
      const text = $('<p>').text(title);
      const li = $('<li>')
        .attr('share-type', type)
        .append(img)
        .append(text);
      list.append(li);
    });
    const menu = $('<div>')
      .addClass('menu')
      .addClass('exit')
      .append(list);
    modal.append(menu);
    const that = this;
    modal.on('click', '[share-type]', function (event) {
      event.stopPropagation();
      const ele = $(this);
      const type = ele.attr('share-type');
      if (type === 'refresh') {
        return window.location.reload();
      }
      let task = null;
      if (type === 'copy') {
        task = (mgApi) => {
          mgApi.sendToClipboard({
            content: that.shareInfo.url || window.location.href,
          });
          that.hideModal();
          that.showToast('复制成功！');
        };
      } else if (type === 'browser') {
        task = (mgApi) => {
          mgApi.openBrowser({
            url: that.shareInfo.url || window.location.href,
          });
        };
      } else {
        if (that.shareCallback) {
          that.shareCallback({ source: 'share-modal', channel: type });
        }
        task = (mgApi) => {
          const {
            desc = '', title = '', img: shareIcon, url,
          } = that.shareInfo;
          mgApi.shareTo({
            type, // 分享平台：wechat(微信好友), moments(微信朋友圈), weibo, qq, qzone, face2face, fantuan, sms
            style: 0, // 分享类型  0(链接), 1(图片)
            title, // 分享标题
            shareUrl: url || window.location.href, // 分享链接
            shareDesc: desc, // 分享描述
            shareIcon, // 分享icon地址
          });
        };
      }
      that.bridge.runTask(task);
    });
    modal.on('click', () => {
      menu.addClass('exit');
      setTimeout(() => {
        this.hideModal();
      }, 300);
    });
  }

  createShareModal() {
    const modal = $('<div>').addClass('pf-share-modal');
    this.createMGMenu(modal);
    this.modal = modal;
  }

  hideModal() {
    this.modal.hide();
  }

  displayModal() {
    const { modal } = this;
    modal.show();
    modal.find('.menu').removeClass('exit');
  }

  destroy() {
    if (this.modal) {
      this.modal.remove();
    }
  }

  showShareModal() {
    console.log(this.shareInfo);
    if (this.shareInfo) {
      this.container = $(document.body);
      if (this.modal) {
        return this.displayModal();
      }
      this.createShareModal();
      this.hideModal();
      this.container.append(this.modal);
      this.displayModal();
    }
    return null;
  }
}
